export default "__VITE_ASSET__Bg49D43U__"